import React from "react";
import styled from "styled-components";
import Benefit from "./Benefit";
import { AttachMoney, AvTimer, Eco } from "@material-ui/icons";
import content from "../../content";

const Info = styled.div<{ $iframeMode?: boolean }>`
  font-size: 1.7em;
  line-height: 1.35;
  font-weight: 600;
  color: white;
  margin-top: ${({ $iframeMode }) => ($iframeMode ? "0" : "100px")};
  text-align: ${({ $iframeMode }) => ($iframeMode ? "center" : "left")};
`;

const BenefitWrapper = styled.div<{ $iframeMode?: boolean }>`
  display: ${({ $iframeMode }) => ($iframeMode ? "grid" : "flex")};
  flex-wrap: wrap;
  width: 100%;
  margin-top: 75px;
  justify-content: ${({ $iframeMode }) =>
    $iframeMode ? "stretch" : "space-between"};
  gap: 30px;
  grid-template-columns: ${({ $iframeMode }) =>
    $iframeMode ? "repeat(3, minmax(0, 1fr))" : "none"};

  @media (max-width: 1100px) {
    grid-template-columns: ${({ $iframeMode }) =>
      $iframeMode ? "1fr" : "none"};
  }
`;

function BenefitsInfo({ iframeMode = false }: IBenefitsInfoProps) {
  return (
    <>
      <Info $iframeMode={iframeMode}>{content.getValue("benefits_header")}</Info>
      <BenefitWrapper $iframeMode={iframeMode}>
        <Benefit
          icon={<AttachMoney />}
          label={content.getValue("benefits_finances")}
        />
        <Benefit icon={<AvTimer />} label={content.getValue("benefits_time")} />
        <Benefit icon={<Eco />} label={content.getValue("benefits_env")} />
      </BenefitWrapper>
    </>
  );
}

export default BenefitsInfo;

export interface IBenefitsInfoProps {
  iframeMode?: boolean;
}
